import { Form as BootstrapForm, Modal, Button } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import MyTextInput from '../form/MyTextInput';
import { useAppDispatch } from '../../store/hooks';
import ButtonLoader from '../../pages/ButtonLoader';
import { changePassword } from '../../store/features/auth';
import { changePasswordValidationSchema } from '../../utility/validationSchema';
import { clearAllLocalStorage, handleSuccess, setDefaultAuthToken } from '../../utility/helpers';

const ChangePassword = ({
    showChangePassword,
    setShowChangePassword
}: any) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [showLoader, setShowLoader] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const requestPayload = (data: any) => {
        return {
            old_password: data.currentPassword,
            password: data.newPassword,
        };
    };

    const handleFormSubmit = (values: any) => {
        const payload = requestPayload(values);
        dispatch(changePassword(payload))
            .unwrap()
            .then((res: any) => {
                setShowLoader(false);
                handleSuccess(res?.detail);
                clearAllLocalStorage();
                setDefaultAuthToken(axios, null);
                navigate('/');
            })
            .catch((error: any) => {
                console.info('Error:', error);
                setShowLoader(false);
            });
    };
    return (
        <>
            < Modal show={showChangePassword}
                    dialogClassName="modal-422 top-right-modal modal-dialog-centered "
                    className="confirmation-modal reset-password-modal"
            >
                <Modal.Body>
                    <h4 className="modal-head modal-head-medium">Change Password.</h4>
                    <p className='modal-subhead'>Set a new password for your profile.</p>
                    <div className='form-wrap'>
                        <Formik
                            initialValues={{
                                currentPassword: '',
                                newPassword: '',
                                confirmPassword: '',
                            }}
                            validationSchema={changePasswordValidationSchema}
                            onSubmit={(values, { setSubmitting }) => {
                                setShowLoader(true);
                                handleFormSubmit(values);
                                setSubmitting(false);
                            }}
                        >
                            {({ errors, touched }) => (
                                <Form className="full-width-form">
                                    <BootstrapForm.Group
                                        className={`form-group password-form-group ${touched.currentPassword && errors.currentPassword ? 'error-field' : ''}`}
                                        controlId="password"
                                    >
                                        <MyTextInput
                                            name="currentPassword"
                                            type={showCurrentPassword ? 'text' : 'password'}
                                            placeholder="Current Password*"
                                            autoComplete="false"
                                        />
                                        <span className="password-toggle">
                                            <span className="show" onClick={() => setShowCurrentPassword(!showCurrentPassword)}>
                                                {showCurrentPassword ? 'Hide' : 'Show'}
                                            </span>
                                        </span>
                                    </BootstrapForm.Group>

                                    <BootstrapForm.Group
                                        className={`form-group password-form-group ${touched.newPassword && errors.newPassword ? 'error-field' : ''}`}
                                        controlId="password"
                                    >
                                        <MyTextInput
                                            name="newPassword"
                                            type={showPassword ? 'text' : 'password'}
                                            placeholder="New Password*"
                                            autoComplete="false"
                                            errorHandling={false}
                                        />
                                        <span className="password-toggle">
                                            <span className="show" onClick={() => setShowPassword(!showPassword)}>
                                                {showPassword ? 'Hide' : 'Show'}
                                            </span>
                                        </span>
                                        <span className={`password-validation ${touched.newPassword && errors.newPassword ? 'error-msg' : ''}`}>
                                            Minimum 8 characters, 1 special character, 1 uppercase character, 1 lowercase character, and must be alphanumeric.
                                        </span>
                                    </BootstrapForm.Group>

                                    <BootstrapForm.Group
                                        className={`form-group password-form-group ${touched.confirmPassword && errors.confirmPassword ? 'error-field' : ''}`}
                                        controlId="confirmPassword"
                                    >
                                        <MyTextInput
                                            name="confirmPassword"
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            placeholder="Confirm New Password*"
                                            autoComplete="false"
                                        />
                                        <span className="password-toggle">
                                            <span className="show" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                                {showConfirmPassword ? 'Hide' : 'Show'}
                                            </span>
                                        </span>
                                    </BootstrapForm.Group>

                                    <div className="sign-btn-wrapper">
                                        <Button variant="primary" className="submit-btn scale" type="submit">
                                            {showLoader ?
                                                <ButtonLoader /> :
                                                'Confirm'
                                            }
                                        </Button>
                                        <Button variant="primary" onClick={() => setShowChangePassword(false)} className="btn-cancel">
                                            cancel
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </Modal.Body>
            </ Modal>
        </>
    );
};

export default ChangePassword;
